import { NamedType } from "../core.models/named-type";
import { getFieldsFromInstance } from "../core.utilidades/graphql-utils";
import { Cliente } from "./cliente";
import { Poliza } from "./poliza";
import { TipoSexo } from "./tipo-sexo";

export class CuestionarioSaludColectivo implements NamedType {
    // evita perder el nombre de clase cuando ivy realiza las optimizaciones de produccion
    _className: string = 'CuestionarioSaludColectivo';

    id?: number;
    cliente: Cliente;
    hospitalizadoSiNo: boolean;
    hospitalizadoDescripcion: string;
    hospitalizadoFecha: string;
    hospitalizadoQuedoBienSiNo: boolean;
    enfermedadSiNo: boolean;
    enfermedadDescripcion: string;
    defectoSiNo: boolean;
    defectoDescripcion: string;
    peso: number;
    altura: number;
    tensionNormalSiNo: boolean;
    tensionMaxima: number;
    tensionMinima: number;
    motocicletaSiNo: boolean;
    motocicletaCilindrada: number;
    deporteSiNo: boolean;
    deporteDescripcion: string;
    activo: boolean;
    poliza: Poliza;

    constructor() {
        this.hospitalizadoSiNo = false;
        this.hospitalizadoDescripcion = '';
        this.hospitalizadoFecha = '';
        this.hospitalizadoQuedoBienSiNo = true;
        this.enfermedadSiNo = false;
        this.enfermedadDescripcion = '';
        this.defectoSiNo = false;
        this.defectoDescripcion = '';
        this.peso = 0;
        this.altura = 0;
        this.tensionNormalSiNo = true;
        this.tensionMaxima = 12;
        this.tensionMinima = 8;
        this.motocicletaSiNo = false;
        this.motocicletaCilindrada = 0;
        this.deporteSiNo = false;
        this.deporteDescripcion = '';

        this.cliente = new Cliente();
        this.poliza = new Poliza();
        this.activo = false;
    }

    public static getFields = () => {
        const instanciaCuestionarioSaludColectivo = new CuestionarioSaludColectivo();
        instanciaCuestionarioSaludColectivo.cliente = new Cliente();
        instanciaCuestionarioSaludColectivo.poliza = new Poliza();
        instanciaCuestionarioSaludColectivo.cliente.fechaNacimiento = new Date();
        instanciaCuestionarioSaludColectivo.cliente.tipoSexo = new TipoSexo();
        return getFieldsFromInstance(instanciaCuestionarioSaludColectivo);
    };
}
